<template>
  <div class="page">
    <StudentPageTree />
  </div>
</template>

<script>
import StudentPageTree from "@/components/objSelectPage/studentTree.vue";
export default {
  name: "StudentSelectTree",
  components: {
    StudentPageTree,
  },
};
</script>

<style lang="less" scoped>
</style>
